import React, { useEffect, useRef, useState } from "react";

import "./news.scss";
import { observer } from "mobx-react-lite";
import { useLocation } from "react-router-dom";
import { CupNewType } from "../../schemas/cup_new";
import CupService from "../../services/cup_service";

import bg from "../../assets/images/backgrounds/cup_new_bg.png";
import ReactSwipe from "react-swipe";
import Footer from "../../components/footer/footer";

function useQuery() {
	const { search } = useLocation();
	return React.useMemo(() => new URLSearchParams(search), [search]);
}

function NewsPage() {
	const id = useQuery().get("id");
	const [cupNew, changeCupNew] = useState<CupNewType>();

	const swiperRef = useRef<ReactSwipe | null>(null);
	const carouselRef = useRef<HTMLDivElement>(null);
	const carouselImageRef = useRef<HTMLDivElement>(null);
	const [currentCard, changeCurrentCard] = useState<number>(0);
	useState<number>();
	const scrollToCard = (card: number) => {
		if (!carouselRef || !carouselRef.current) return;
		if (!carouselImageRef || !carouselImageRef.current) return;
		carouselRef.current.scrollLeft =
			card *
			((carouselImageRef.current.offsetWidth / 235) * (235 + 16 * 2));
		// Добавляем к ширине margin блока. Должно совпадать со значениями в css
		changeCurrentCard(card);
		swiperRef.current?.slide(card, 0);
	};

	useEffect(() => {
		(async () => {
			if (id) {
				changeCupNew(await CupService.getCupNew(+id));
			}
		})();
		setTimeout(() => {
			changeCurrentCard(0);
		}, 1000);
	}, [id]);

	useEffect(() => {
		document.title = "БЕТСИТИ Кубок Столетия";
	});

	return (
		<div className="cup_news_page_wrapper">
			{cupNew && (
				<div className="cup_news_wrapper">
					{cupNew.top_pic && (
						<div className="cover">
							<img src={cupNew.top_pic} alt=""></img>
						</div>
					)}

					<div className="bg_wrapper">
						<img src={bg} alt=""></img>
					</div>
					<div className="content_wrapper">
						{cupNew.time &&
							cupNew.date.day &&
							cupNew.date.monthName &&
							cupNew.date.year && (
								<div className="date_wrapper">
									{cupNew.time} {cupNew.date.day}{" "}
									{cupNew.date.monthName} {cupNew.date.year}
								</div>
							)}

						<div className="card">
							<div className="card_header">
								<div className="title">{cupNew.name}</div>
								<div className="description">
									{cupNew.anons}
								</div>
							</div>
							<div
								className="card_content"
								dangerouslySetInnerHTML={{
									__html: cupNew.detail_text,
								}}
							></div>
						</div>

						<div
							className="images_wrapper"
							onTouchEnd={() => {
								if (swiperRef.current) {
									changeCurrentCard(
										swiperRef.current.getPos()
									);
									changeCurrentCard(
										swiperRef.current.getPos()
									);
								}
							}}
						>
							<ReactSwipe
								swipeOptions={{ continuous: false }}
								ref={swiperRef}
								className="carousel"
							>
								{cupNew.images.map((image, index) => (
									<img src={image} alt="" key={index}></img>
								))}
							</ReactSwipe>
							{currentCard !== undefined && (
								<div className="pagination">
									<div className="pages_wrapper">
										<div
											className={
												"page f " +
												(currentCard === 0
													? "active"
													: "")
											}
										></div>
										<div
											className={
												"page m " +
												(currentCard !== 0 &&
												currentCard !==
													cupNew.images.length - 1
													? "active"
													: "")
											}
										></div>
										<div
											className={
												"page l " +
												(currentCard ===
												cupNew.images.length - 1
													? "active"
													: "")
											}
										></div>
									</div>
								</div>
							)}
						</div>

						<div className="images_slider_wrapper">
							<div
								className="prev button"
								onClick={() => {
									if (currentCard === 0) return;
									scrollToCard(currentCard - 1);
								}}
							>
								<i className="arrow left"></i>
							</div>
							<div
								className="next button"
								onClick={() => {
									if (currentCard === cupNew.images.length)
										return;
									scrollToCard(currentCard + 1);
								}}
							>
								<i className="arrow right"></i>
							</div>
							<div className="images_carousel" ref={carouselRef}>
								{cupNew.images.map((image, index) => (
									<div
										className={
											"news_image_wrapper " +
											(index < currentCard ||
											index + 1 > currentCard + 3
												? "smoke "
												: "") +
											(index === currentCard
												? "active"
												: "")
										}
										key={index}
										ref={carouselImageRef}
									>
										<img src={image} alt=""></img>
									</div>
								))}
							</div>
						</div>

						<div className="sponsor_block_wrapper">
							{cupNew.name_sponsor && (
								<div className="sponsor_block">
									{cupNew.name_sponsor}
								</div>
							)}

							{cupNew.pic_sponsor && (
								<div className="sponsor_logo">
									<img src={cupNew.pic_sponsor} alt=""></img>
								</div>
							)}
						</div>
					</div>
				</div>
			)}
			<Footer></Footer>
		</div>
	);
}

export default observer(NewsPage);
